import Instrument from "../Instrument";

class DrumKit808 extends Instrument {

	constructor(path) {
		super("DrumKit808", DrumKit808.nice_name, path);

		this.createParameter("octave", {
			min: -1,
			max: 4,
			default: 1,
			lock_step: true
		});

		this.samples = [
			"808/kick1.wav",
			"808/kick2.wav",
			"808/handclap.wav",
			"808/snare.wav",
			"808/cl_hihat.wav",
			"808/open_hh.wav",
			"808/rimshot.wav",
			"808/claves.wav",
			"808/tom1.wav",
			"808/hightom.wav",
			"808/maracas.wav",
			"808/conga1.wav",
			"808/hi_conga.wav",
			"808/crashcym.wav",
		];

		this.loaded = false;
		this.context = false;
	}

	scheduleNote(notes, time, tonic, scale) {
		var len = notes.length;
		if(len > 0 && this.loaded) {
			for(var i = len - 1; i >= 0; i--) {
				this.playSample(this.context, this.gain, this.samples[notes[i]], time);
			}
		}
	}

	getNotesNames() {
		return [
			"Kick 1", "Kick 2", "Clap", "Snare", "CHH", "OHH", "Rim",
			"Claves", "LTom", "HTom", "Maracas", "LCon", "HCon", "Crash"
		]
	}

	createNodes(context) {

		this.loadSamples(context, this.samples).then(() => {
			this.loaded = true;
		});

		this.context = context;

		var gainNode = context.createGain();

		gainNode.gain.value = 1;

		this.gain = gainNode;

		return {
			connect: (node) => {
				gainNode.connect(node);
			},
			disconnect: (node) => {
				gainNode.disconnect(node);
			}
		};

	}
}

DrumKit808.nice_name = '808 Kit';

export default DrumKit808;
